export default __webpack_public_path__ + "static/media/branding-logo.00626091.svg";